import { useCallback, useState } from "react";
import { useService } from "../../../../hooks";
import { searchRegex } from "../../../../constant";

export const useStoreLocatorSideBar = () => {
  const { fetchByAttr } = useService("Data", "franchise");
  const [franchiseList, setfranchiseList] = useState([]);
  const [filteredFranchiseList, setfilteredFranchiseList] = useState([]);
  const [searchFranchiseKey, setsearchFranchiseKey] = useState<string>("");

  const getFranchisesData = useCallback(async () => {
    const result = await fetchByAttr({ status: "publish" });
    if (result.status) {
      setfranchiseList(result.data);
      setfilteredFranchiseList(result.data);
    }
  }, [fetchByAttr]);

  const searchFranchise = useCallback(
    (e) => {
      if (e.target.value === "" || searchRegex.test(e.target.value)) {
        setsearchFranchiseKey(e.target.value);
        let tempTitle = "",
          filteredFranchiseList = [];
        franchiseList.forEach((e) => {
          tempTitle = e.title.toLowerCase();
          if (tempTitle.search(searchFranchiseKey.toLowerCase()) !== -1) {
            filteredFranchiseList.push(e);
          }
        });
        setfilteredFranchiseList(filteredFranchiseList);
      }
    },
    [franchiseList, searchFranchiseKey]
  );

  const fetchFranchiseData = useCallback(() => {
    if (franchiseList.length === 0) getFranchisesData();
  }, [getFranchisesData, franchiseList]);
  return {
    fetchFranchiseData,
    filteredFranchiseList,
    searchFranchiseKey,
    searchFranchise,
  };
};
